export default "__VITE_ASSET__BjQfhFq2__";